import { Component, Input, OnInit, OnDestroy, ViewChild, inject } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { ExecutiveDashboardComponent } from './executive-dashboard/executive-dashboard.component';
import { ActivatedRoute } from "@angular/router";
import { OperationalDashboardComponent } from './operational-dashboard/operational-dashboard.component';
import { GlobalInsightsComponent } from './global-insights/global-insights.component';
import { ComparisonInsightsComponent } from './comparison-insights/comparison-insights.component';
import { MedicationInsightsComponent } from './medication-insights/medication-insights.component';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-insights-home',
    templateUrl: './insights.component.html',
    styleUrls: ['./insights.component.scss'],
    standalone: false
})
export class InsightsComponent implements OnInit, OnDestroy {
  authService = inject(AuthService);
  private route = inject(ActivatedRoute);


  moduleName="INSIGHTS"
  selectedDays = 7;
  filterValues:any = {};
  @Input() deId=false;
  showOp = true;
  showExec = true;
  showMed = true;
  activeTab = "0";
  date: any = {};
  dissableDeIdSwitch = false;
  @ViewChild('executiveDashboard') executiveDashboard!:ExecutiveDashboardComponent;
  @ViewChild('operationalDashboard') operationalDashboard!:OperationalDashboardComponent;
  @ViewChild('GlobalInsightsComponent') globalDash!:GlobalInsightsComponent;
  @ViewChild('ComparisonInsightsComponent') comparisonDash!:ComparisonInsightsComponent;
  @ViewChild('MedicationInsights') MedicationInsights!:MedicationInsightsComponent;
  private readonly destroy$ = new Subject<void>();


  ngOnInit(): void {
    const deIdState = this.authService.getDeIdState();
    this.deId = deIdState.value;
    this.dissableDeIdSwitch = deIdState.disabled;

    this.route.data.pipe(takeUntil(this.destroy$)).subscribe(x => {
      this.deId = this.authService.isDemoUser() ? true : x.deId;
    });
    const body = document.getElementsByTagName('body')[0];
    body.className ="";
    body.classList.add('subpage');
    body.classList.add('insights');
    
    // Set initial module name to match default tab
    this.moduleName = "Enterprise Insights";
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  tabChanged(event: any){
    if(event.index==0){
      this.moduleName= "EXECTUTIVE"
      this.executiveDashboard.refreshData();
    }
    if(event.index==1){
      this.moduleName= "OPERATIONAL"
      this.operationalDashboard.triggerRefresh();
    }
    if(event.index==2){
      this.moduleName= "MEDICATION"
      this.MedicationInsights.refreshData();
    }
  }

  updatedFilterValue(filter: any){
    this.filterValues = filter;
  }

  updatedDate(filter: any){
    this.date.startDate = new Date(this.gdfs(filter.startDate)).setHours(0,0,0);
    this.date.endDate = new Date(this.gdfs(filter.endDate)).setHours(23,59,59);
  }

  gdfs(s: any){
    // get date from string 
    const d = s.substring(0,10).split('-')
    return d[1] + '-' + d[2] + '-' + d[0]
  }

  getUserRole(){
    return this.authService.user.role;
  }
  
  updateDeIdMode(value: boolean) {
    if (!this.authService.isDemoUser()) {
      this.deId = value;
      this.authService.setDeIdentified(value);
    }
  }

  // updateLookbackPeriod(event){
  //   this.executiveDashboard.updateLookbackPeriod(lookbackPeriod);
  // }
  
}